import { type JSX } from 'solid-js';

export type BadgeTone = 'brand' | 'neutral' | 'success' | 'warning' | 'danger' | 'cyan';

export function Badge(props: { tone?: BadgeTone; dot?: boolean; pulse?: boolean; children: JSX.Element }): JSX.Element {
  return (
    <span class={`tk-badge tk-badge--${props.tone ?? 'brand'}`}>
      {props.dot && <span class={`tk-badge__dot ${props.pulse ? 'tk-badge__dot--pulse' : ''}`} />}
      {props.children}
    </span>
  );
}

export function Tag(props: { children: JSX.Element }): JSX.Element {
  return <span class="tk-tag">{props.children}</span>;
}
